module.exports = __webpack_public_path__ + "img/yanzhengma.bd93f38f.png";